export default __webpack_public_path__ + "static/media/stepper-grey.0c86f2dc.svg";